export const settings = function () {
  let devSet = {
    "endpoint": "/",
    "endpoints": "/",
    "imageAction": "//open.dev.simmed.cn/api/image/image",
    "appid": "ww54e247995a0d9a9b",
    "agentid": "1000022",
    "redirect_uri": "https%3a%2f%2fyundev.simmed.cn%2f%23%2flogin",
    "environment": '开发'
    // "redirect_uri": "http%3a%2f%2fweizw.wicp.net:21363%2f%23%2flogin"
  };
  let onlineSet = {
    "endpoint": "/",
    "endpoints": "/",
    "imageAction": "/api/image/image",
    "appid": "ww54e247995a0d9a9b",
    "agentid": "1000024",
    "redirect_uri": "https%3a%2f%2fyun.simmed.cn%2f%23%2flogin",
    "environment": '正式'
  };



  let set = onlineSet;
  if (location.href.indexOf('dev.simmed.cn') >= 0) {
    set = devSet;
  }
  return set;
}



// WEBPACK FOOTER //
// ./src/setting.js